import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Link,
  styled,
  Toolbar,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { menuItems } from "../data/menuItems";
import logo from "../assets/images/logo512.png";
import MenuItemList from "../components/menuItems";
import api from "../helper/baseApi";
import { useEffect, useState } from "react";
import { useApiClient } from "../context/ApiClientContext";

const drawerWidth = 210;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    background: theme.palette.background.main,
    color: theme.palette.primary.main,
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    paddingTop: "60px",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

const LeftMenuDrawer = ({ open, toggleDrawerCallback, logoutCallback }) => {
  const [userPlan, setUserPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const { apiUrls: { mobileApiUrl } } = useApiClient();
  const canAccessAccount = (plan) => ["Pro", "Enterprise"].includes(plan);

  useEffect(() => {
    const fetchUserPlan = async () => {
      try {
        const apiUrl = `${mobileApiUrl}user/user-package`;
        const res = await api.get(apiUrl);

        setUserPlan(res.data.subscriptionPackageName); 
      } catch (error) {
        console.error("Failed to fetch user plan:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserPlan();
  }, []);

  const mainItems = menuItems.filter(
    (item) => !["Notifications", "Account", "Logout"].includes(item.label)
  );

  const bottomItems = menuItems.filter((item) => {
    if (["Notifications","Account", "Logout"].includes(item.label)) return true;
    // if (item.label === "Account") return canAccessAccount(userPlan);
    return false;
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (isMobile) {
    return (
      <MuiDrawer
        variant="temporary"
        open={open}
        onClose={toggleDrawerCallback}
        ModalProps={{ keepMounted: true }}
        sx={{
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            paddingTop: "75px", // leave space for AppBar
          },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <MenuItemList
            items={mainItems}
            showText={true}
            toggleDrawerCallback={toggleDrawerCallback}
          />
          <Box sx={{ flexGrow: 1 }} />
          <MenuItemList
            items={bottomItems}
            showText={true}
            toggleDrawerCallback={toggleDrawerCallback}
          />
        </Box>
      </MuiDrawer>
    );
  }

  return (
    <Drawer
      variant="permanent"
      open={open}
      onClose={toggleDrawerCallback}
      sx={{
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          display: "flex",
          flexDirection: "column",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
      }}
    >

      <Box
        sx={{
          flex: "1 1 auto",
          overflowY: "auto",
          mb:2.5,
          display: "flex",
          flexDirection: "column",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <MenuItemList items={mainItems} showText={!isMobile} toggleDrawerCallback={toggleDrawerCallback} />

        <Box sx={{ flexGrow: 1 }} />

        <MenuItemList items={bottomItems} showText={!isMobile} toggleDrawerCallback={toggleDrawerCallback} />

      </Box>
    </Drawer>
  );
};

export default LeftMenuDrawer;
